const pageDelete = {
    execute: function () {
        $("#deleteAccount").submit();
    },

    // バリデーションが完全に通った
    validated: function () {
        $(".js-modal-show").removeClass("button-general--disabled");
    },
    validateFail: function () {
        $(".js-modal-show").addClass("button-general--disabled");
    }
};

window.pageDelete = pageDelete;

$(document).ready(function (e) {
    if ($(".js-delete-page").length === 0) {
        return;
    }

    // 確認
    $(".js-confirm").click(function () {
        pageDelete.execute();
    });

    // フォームを変更したときの挙動
    $("#deleteAccount")
        .find('input, input[type="radio"]:checked, select, textarea')
        .change(function () {
            form.post(
                "/parent/deleteAccount/ajaxValidation",
                "#deleteAccount",
                "",
                pageDelete.validated,
                pageDelete.validateFail
            );
        });
});
